import React from 'react';
import { styled } from "../../stitches.config"


interface DateBadgeProps {
    type?: "fill" | "outline" | "gray";
    dayText?: string;
    dateText?: string;
}

const DateBadge: React.FC<DateBadgeProps> = ({
    type = "fill",
    dateText,
    dayText
}) => {
    return (
        <StyledDateBadge type={type}>
            {dayText}{dateText && <><span></span>{dateText}</>}
        </StyledDateBadge>
    );
};

const StyledDateBadge = styled('div', {
    width: "max-content",
    padding: "3px 5px",
    fontFamily: "HK Grotesk",
    fontStyle: "normal",
    fontWeight: "800",
    fontSize: "12px",
    lineHeight: "16px",
    display: "flex",
    alignItems: "center",
    "@bp4": {
        padding: "4px 6px",
    },
    variants: {
        type: {
            fill: {
                backgroundColor: "$primary",
                color: "$grayscale0",
                '& span': {
                    backgroundColor: "$grayscale0",
                }

            },
            outline: {
                border: "1px solid $primary",
                color: "$primary",
                '& span': {
                    backgroundColor: "$primary",
                }

            },
            gray: {
                border: "1px solid $grayscale50",
                color: "$grayscale50",
                '& span': {
                    backgroundColor: "$grayscale50",
                }

            }
        }
    },
    '& span': {
        height: "2px",
        width: "2px",
        borderRadius: "50%",
        margin: "0 5px",
        display: "block"
    }
})


export default DateBadge